import { render } from "./StudentDiscipline.vue?vue&type=template&id=3ad5468e"
import script from "./StudentDiscipline.vue?vue&type=script&lang=js"
export * from "./StudentDiscipline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__